/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Serve_Tunnel_OnInputs */

const en_serve_tunnel_on = /** @type {(inputs: Serve_Tunnel_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`phone preview connected`)
};

const id_serve_tunnel_on = /** @type {(inputs: Serve_Tunnel_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tampilan HP tersambung`)
};

/**
* | output |
* | --- |
* | "phone preview connected" |
*
* @param {Serve_Tunnel_OnInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const serve_tunnel_on = /** @type {((inputs?: Serve_Tunnel_OnInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Serve_Tunnel_OnInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_serve_tunnel_on(inputs)
	return en_serve_tunnel_on(inputs)
});